module.exports = __webpack_public_path__ + "media/images/young_pin_design_award_img-514b3c8c95a69e69d5fe458177c31233.jpg";